<template lang="pug">
menu-bar-item(:label=`$t('bookmarks')`)
  menu-item(:label=`$t('add_bookmark')`, keybind="ctrl+D", v-model="module.showAddBookmark")
  menu-item(:label=`$t('edit_bookmarks')`, keybind="ctrl+shift+D", v-model="module.showEditBookmarks")
  menu-separator
  menu-item(:label=`$t('export')`, @click="module.exportJson", :sync="true")
  menu-item(:label=`$t('import')`, @click="module.importJson", :sync="true")
  menu-separator
  menu-item(:label=`$t('import_from_hscmap2')`, @click="module.importFromHscMap2")
  menu-separator
  menu-item(:label=`$t('walk_setting')`, v-model="module.showWalkSetting")
  menu-item(:label=`$t('walk_all_bookmarks')`, @click="walkAllBookmarks")
  menu-item(:label=`$t('stop')`, :disabled="! module.walking", @click="stop", keybind="Escape")
  menu-separator
  bookmark-entry(v-for="entry in module.root.children", :entry="entry", :key="Id(entry)")
  menu-separator
  bookmark-entry(:entry="module.recommendedBookmarks($root.$i18n.locale)")
</template>


<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";
import BookmarkEntry from './BookmarkEntry.vue'
import { walkBookmarks } from '../walk';
import { FrameStore } from "@/modules/base";
import { BookmarkModule, IBookmarkFolder } from "@/modules/BookMarkModule";
import { store } from '@/store';

@Component({
  components: {
    BookmarkEntry,
  },
})
export default class extends Vue {
  @Prop({ required: true })
  module!: FrameStore<typeof BookmarkModule>

  walkAllBookmarks() {
    walkBookmarks(this.module.root, store, this.module)
  }

  stop() {
    this.module.walking = false
  }
}
</script>

<i18n>
en:
  bookmarks: Bookmarks
  add_bookmark: Add Bookmark...
  edit_bookmarks: Edit Bookmarks...
  export: Export
  import: Import
  import_from_hscmap2: Import from hscMap2...
  walk_setting: Walk Setting...
  walk_all_bookmarks: Walk All Bookmarks
  stop: Stop Walking
  recommended: Recommended Objects
ja:
  bookmarks: ブックマーク
  add_bookmark: 追加...
  edit_bookmarks: 編集...
  export: エクスポート
  import: インポート...
  import_from_hscmap2: hscMap2からインポート...
  walk_setting: 巡回設定...
  walk_all_bookmarks: 全てのブックマークを巡回
  stop: 巡回停止
  recommended: オススメ天体
</i18n>